import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/AppShell';
import { InboxView } from '@/features/inbox/InboxView';

export const Route = createFileRoute('/inbox')({
  component: () => (
    <AppShell>
      <InboxView />
    </AppShell>
  ),
});
